// extracted by mini-css-extract-plugin
export default {"ReplyButton":"pn_a bhr_wx bhr_jb bhr_xl bhr_i bhr_j bhr_q bhr_vt bhr_et bhr_so bhr_sp bhr_eg","ReplyButton__icon":"pn_b bhr_rz"};